import React from 'react'
import styles from './MobileOnly.module.scss'

interface MobileOnlyProps {
  children: React.ReactNode
  className?: never
}

export const MobileOnly: React.FC<MobileOnlyProps> = ({ children }) => (
  <span className={styles.mobileOnly}>{children}</span>
)
